import DOMPurify from 'dompurify';
import { decodeHTML } from 'entities';

const BLOCK_BOUNDARY = /<\/(?:p|div|li|h[1-6]|tr)>|<br\s*\/?>/gi;

// Decoded before stripping: some listings send entity-encoded markup, which would otherwise survive as visible text.
export function htmlToPlainText(html: string | null | undefined): string {
  if (!html) return '';

  const decoded = decodeHTML(html)
    .replace(/<!\[CDATA\[|\]\]>/g, '')
    .replace(BLOCK_BOUNDARY, ' ');
  const text = DOMPurify.sanitize(decoded, { ALLOWED_TAGS: [], KEEP_CONTENT: true });

  return decodeHTML(text).replace(/\s+/g, ' ').trim();
}
